// §29.10 / §9.1 — Vines as an in-process app.
//
// Manifest only (D-247): the engine, the view, the CSS and the sprite sheet all live behind the
// thunk, so a desktop that never opens this window never downloads any of it (D-199, D-367).
//
// Not a factory. Vines is single-player — §30.1's multiplayer allowlist does not name it — so it
// needs no `PlayShellAccess` and taking one would imply a session it never opens.
import type { InProcessApp } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';

export function createVinesApp(): InProcessApp {
  return createLazyApp({
    app: {
      id: 'vines',
      name: 'Vines',
      // §29.1 (D-379) — the glyph is fixed by the roster, not chosen here.
      icon: { glyph: 'sprout', hue: 140 },
      keywords: ['climb', 'vines', 'rescue', 'jungle', 'fruit', 'game', 'arcade'],
      category: 'Arcade',
      // §29.1 (D-369) — the sub-group header this title sits under in the launcher and the Store.
      group: 'Action',
      requiresAuth: true,
      // Fixed-aspect letterboxed canvas (D-229, D-374). §29.10's climb model is stated in **cells
      // per second**, so a stretched field would make 4 up and 8 down mean different speeds in
      // different windows — the one number in this game a player learns by feel.
      window: { width: 720, height: 720, minWidth: 460, minHeight: 460, multiWindow: false },
      jumpList: [{ id: 'new-game', label: 'New game' }],
    },
    load: () => import('./Vines'),
  });
}
